import { TranslateManager } from "@core/translate/translate.manager";

export const translateManagerFactory = (translateManager:TranslateManager) => () => translateManager.init()